

import { MultiSelectChangeEvent } from "@progress/kendo-react-dropdowns";
import { Error } from "@progress/kendo-react-labels";
import React, { useEffect } from "react";
import {
    DeepMap,
    FieldError,
    UseFormRegister,
    Path,
    Controller,
    FieldValues
} from 'react-hook-form';
import MultiSelectDropdown, {Props} from '../components/multiSelect';

export type MultiDropDownInputProps<TFormValues extends FieldValues> = {
    name: Path<TFormValues>;
    data?: any;
    onchange?: any;
    defaultValue?: any
    label?:string;
    disabled?:boolean;
    placeholder?:string,
    value?:any;
    dataItemKey?:any;
    // textField?:string;
    register?: UseFormRegister<TFormValues>;
    // dataItemKey?: any,
    errors?: Partial<DeepMap<TFormValues, FieldError>>;
    control?: any;
    ref?: any;
    allowCustom?: boolean;
} & Omit<Props, 'name'>;

export const MultiDropDownInput = <TFormValues extends Record<string, unknown>>({
    name,
    register,
    errors,
    label,
    value,
    disabled,
    textField,
    placeholder,
    data,
    dataItemKey,
    onchange,
    defaultValue,
    control,
    ref,
    allowCustom,
    ...props

}: MultiDropDownInputProps<TFormValues>): JSX.Element => {
    // If the name is in a FieldArray, it will be 'fields.index.fieldName' and errors[name] won't return anything, so we are using lodash get
    //   const errorMessages = get(errors, name);
    const hasError = !!(errors);
    const [poli, setPoli] = React.useState([
        // Since the items references of the initial value are not from the 'sports' collection,
        // 'dataItemKey' have to be set.
      ]);

    // const handleChange = (event: MultiSelectChangeEvent) => {
    //     setPoli(event.value);
    //   };
    return (
    <div className={`form-group ${errors?.[name]?.message ? 'errorFiled' : ""}`} aria-live="polite">
        {label && <label className="lablel">{label}</label>}
        {data && <Controller 
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
                <MultiSelectDropdown
                    data={data}
                    disabled={disabled}
                    value={value}
                    defaultValue={defaultValue}
                    dataItemKey={dataItemKey}
                    placeholder={placeholder}
                    textField={textField}
                    allowCustom={allowCustom === false ? false : true}
                    // aria-invalid={hasError}
                    // {...props}
                    onChange={onChange}
                    // {...(register && register(name, {
                    //     onChange: (e) => onchange ? onChange(e) : null  }
                    // ))}
                    ref={null}
                />
            )}
        />}
        <Error>{errors?.[name]?.message}</Error>
    </div>
    );
};
